// API endpoints organized by category
export const endpointCategories = {
  "User Management": [
    {
      name: "Get User Profile",
      method: "GET",
      path: "/users/api/v1/users/{userId}",
      fnName: "getUserProfile",
      params: ["userId"],
    },
    {
      name: "Update User Profile",
      method: "PUT",
      path: "/users/api/v1/users/{userId}",
      fnName: "updateUserProfile",
      params: ["userId", "data"],
    },
    {
      name: "Delete User Account",
      method: "DELETE",
      path: "/users/api/v1/user/{userId}",
      fnName: "deleteUserAccount",
      params: ["userId"],
    },
    {
      name: "Update User Status",
      method: "PATCH",
      path: "/users/api/v1/users/{userId}/status",
      fnName: "updateUserStatus",
      params: ["userId", "active", "ownerId"],
    },
    {
      name: "Invite Users",
      method: "POST",
      path: "/users/api/v1/users/invite",
      fnName: "inviteUsers",
      params: ["payload"],
    },
    {
      name: "Bulk Invite Users",
      method: "POST",
      path: "/users/api/v1/users/invite/bulk",
      fnName: "bulkInviteUsers",
      params: ["formData"],
    },
    {
      name: "Get Sub Accounts",
      method: "GET",
      path: "/users/api/v1/users/{ownerId}/sub-accounts",
      fnName: "getSubAccounts",
      params: ["ownerId", "params"],
    },
    {
      name: "Delete User By Id",
      method: "DELETE",
      path: "/users/api/v1/users/delete-by-id/{userId}",
      fnName: "deleteUserById",
      params: ["userId", "ownerId"],
    },
  ],
  "Booking Management": [
    {
      name: "Get Bookings",
      method: "GET",
      path: "/booking/api/v1/booking",
      fnName: "getBookings",
      params: ["params"],
    },
    {
      name: "Get User Bookings",
      method: "GET",
      path: "/booking/api/v1/booking/{userId}",
      fnName: "getUserBookings",
      params: ["userId", "params"],
    },
    {
      name: "Get User Individual Bookings",
      method: "GET",
      path: "/booking/api/v1/booking/{userId}?visibility=INDIVIDUAL",
      fnName: "getUserIndividualBookings",
      params: ["userId", "params"],
    },
    {
      name: "Get User Team Bookings",
      method: "GET",
      path: "/booking/api/v1/booking/{userId}?visibility=TEAM",
      fnName: "getUserTeamBookings",
      params: ["userId", "params"],
    },
    {
      name: "Get User Company Bookings",
      method: "GET",
      path: "/booking/api/v1/booking/{userId}?visibility=COMPANY",
      fnName: "getUserCompanyBookings",
      params: ["userId", "params"],
    },
    {
      name: "Create Booking",
      method: "POST",
      path: "/booking/api/v1/booking",
      fnName: "createBooking",
      params: ["payload"],
    },
    {
      name: "Cancel Booking",
      method: "PATCH",
      path: "/booking/api/v1/booking/{bookingId}/cancel",
      fnName: "cancelBooking",
      params: ["bookingId", "userId"],
    },
    {
      name: "Create Team Booking",
      method: "POST",
      path: "/booking/api/v1/booking",
      fnName: "createTeamBooking",
      params: ["payload"],
    },
    {
      name: "Create Company Booking",
      method: "POST",
      path: "/booking/api/v1/booking",
      fnName: "createCompanyBooking",
      params: ["payload"],
    },
    {
      name: "Create Individual Booking",
      method: "POST",
      path: "/booking/api/v1/booking",
      fnName: "createIndividualBooking",
      params: ["payload"],
    },
    {
      name: "Check In/Out",
      method: "GET",
      path: "/booking/booking/{bookingId}/checkInOrOut",
      fnName: "checkInOrOut",
      params: ["bookingId", "userId", "username"],
    },
  ],
  "Listings Management": [
    {
      name: "Get All Listings",
      method: "GET",
      path: "/booking/api/v1/listings",
      fnName: "getAllListings",
      params: ["params"],
    },
    {
      name: "Get User Listings",
      method: "GET",
      path: "/booking/api/v1/listings/{userId}",
      fnName: "getUserListings",
      params: ["userId", "params"],
    },
    {
      name: "Get Listing By Id",
      method: "GET",
      path: "/booking/api/v1/listings/by/id/{id}",
      fnName: "getListingById",
      params: ["id"],
    },
    {
      name: "Create Listing Media",
      method: "POST",
      path: "/booking/api/v1/listings/media",
      fnName: "createListingMedia",
      params: ["payload", "userId"],
    },
    {
      name: "Create Listing",
      method: "POST",
      path: "/booking/api/v1/listings",
      fnName: "createListing",
      params: ["payload"],
    },
    {
      name: "Update Listing",
      method: "PUT",
      path: "/booking/api/v1/listings/{listingId}",
      fnName: "updateListing",
      params: ["listingId", "payload"],
    },
    {
      name: "Delete Listing",
      method: "DELETE",
      path: "/booking/api/v1/listings/{id}",
      fnName: "deleteListing",
      params: ["id", "userId"],
    },
    {
      name: "Publish Listing",
      method: "PUT",
      path: "/booking/api/v1/listings/{id}/publish",
      fnName: "publishListing",
      params: ["id", "userId"],
    },
    {
      name: "Unpublish Listing",
      method: "PATCH",
      path: "/booking/api/v1/listings/{id}/unpublish",
      fnName: "unpublishListing",
      params: ["id", "userId"],
    },
    {
      name: "Search Listings",
      method: "POST",
      path: "/booking/api/v1/listings/search",
      fnName: "searchListings",
      params: ["data", "params"],
    },
  ],
  "Company Management": [
    {
      name: "Get Company Details By Id",
      method: "GET",
      path: "/platform/company/v1/company/{id}",
      fnName: "getCompanyDetailsById",
      params: ["id", "userId"],
    },
    {
      name: "Get Company Details By Number",
      method: "GET",
      path: "/platform/company/v1/company/{companyId}",
      fnName: "getCompanyDetailsByNumber",
      params: ["companyId", "userId"],
    },
    {
      name: "Update Company Profile",
      method: "PUT",
      path: "/platform/company/v1/company/{companyId}",
      fnName: "updateCompanyProfile",
      params: ["companyId", "payload", "headers"],
    },
    {
      name: "Get Approved Hosts",
      method: "GET",
      path: "/platform/company/v1/company/corporate/customer/status",
      fnName: "getApprovedHosts",
      params: ["page", "search"],
    },
    {
      name: "Get Pending Hosts",
      method: "GET",
      path: "/platform/company/v1/company/corporate/customer/status",
      fnName: "getPendingHosts",
      params: ["page", "search"],
    },
    {
      name: "Get Disabled Hosts",
      method: "GET",
      path: "/platform/company/v1/company/corporate/customer/status",
      fnName: "getDisabledHosts",
      params: ["page", "search"],
    },
    {
      name: "Update Company Status",
      method: "PATCH",
      path: "/platform/company/v1/company/enable",
      fnName: "updateCompanyStatus",
      params: ["companyIds", "userId", "enable", "declineReason"],
    },
  ],
  "Notifications & Announcements": [
    {
      name: "Get Notifications",
      method: "GET",
      path: "/messaging/api/v1/push-notifications",
      fnName: "getNotifications",
      params: ["userId", "page", "size"],
    },
    {
      name: "Mark Notification As Read",
      method: "PATCH",
      path: "/messaging/api/v1/push-notifications/{notificationId}/users/{userId}/read-status",
      fnName: "markNotificationAsRead",
      params: ["notificationId", "userId"],
    },
    {
      name: "Mark All Notifications As Read",
      method: "PATCH",
      path: "/messaging/api/v1/push-notifications/users/{userId}/mark-all-read",
      fnName: "markAllNotificationsAsRead",
      params: ["userId"],
    },
    {
      name: "Create Announcement",
      method: "POST",
      path: "/messaging/api/v1/push-notifications/add",
      fnName: "createAnnouncement",
      params: ["payload"],
    },
    {
      name: "Update Notification",
      method: "PUT",
      path: "/messaging/api/v1/push-notifications/{id}",
      fnName: "updateAnnouncement",
      params: ["id", "payload"],
    },
    {
      name: "Delete Notification",
      method: "DELETE",
      path: "/messaging/api/v1/push-notifications/notification/{notificationId}",
      fnName: "deleteAnnouncement",
      params: ["notificationId"],
    },
    {
      name: "Search Users",
      method: "GET",
      path: "/messaging/api/v1/push-notifications/users/search",
      fnName: "searchUsers",
      params: ["searchTerm"],
    },
  ],
  "Billing & Payments": [
    {
      name: "Get Invoices",
      method: "GET",
      path: "/booking/api/v1/order/invoices",
      fnName: "getInvoices",
      params: ["userId", "params"],
    },
    {
      name: "Get Unpaid Invoices",
      method: "GET",
      path: "/booking/api/v1/order/invoices",
      fnName: "getUnpaidInvoices",
      params: ["userId", "searchValue"],
    },
    {
      name: "Download Invoice",
      method: "GET",
      path: "/users/invoice/{userId}/{token}.pdf",
      fnName: "downloadInvoice",
      params: ["userId", "token"],
    },
    {
      name: "Download Statement",
      method: "GET",
      path: "/users/v1/customer/account/transactions/statement.pdf",
      fnName: "downloadStatement",
      params: ["userId", "startAt", "endAt"],
    },
    {
      name: "Process Payment",
      method: "POST",
      path: "/users/v1.1/process/payment",
      fnName: "processPayment",
      params: ["payload", "userId"],
    },
    {
      name: "Get Mobile Wallet Accounts",
      method: "GET",
      path: "/users/v1/user/{userId}/payment/methods",
      fnName: "getMobileWalletAccounts",
      params: ["userId"],
    },
  ],
  "Teams & Groups": [
    {
      name: "Get Company Groups",
      method: "GET",
      path: "/users/api/groups",
      fnName: "getCompanyGroups",
      params: ["page", "size"],
    },
    {
      name: "Create Group",
      method: "POST",
      path: "/users/api/groups/users",
      fnName: "createGroup",
      params: ["name", "userIds"],
    },
    {
      name: "Add Users To Group",
      method: "PATCH",
      path: "/users/api/groups/{groupId}",
      fnName: "addUsersToGroup",
      params: ["groupId", "userIds"],
    },
    {
      name: "Remove Users From Group",
      method: "PATCH",
      path: "/users/api/groups/{groupId}",
      fnName: "removeUsersFromGroup",
      params: ["groupId", "userIds"],
    },
    {
      name: "Update Group Name",
      method: "PATCH",
      path: "/users/api/groups/{groupId}",
      fnName: "updateGroupName",
      params: ["groupId", "name"],
    },
    {
      name: "Get Group Members",
      method: "GET",
      path: "/users/api/groups/{groupId}/users",
      fnName: "getGroupMembers",
      params: ["groupId", "page", "size"],
    },
    {
      name: "Delete Group",
      method: "DELETE",
      path: "/users/api/groups/{groupId}",
      fnName: "deleteGroup",
      params: ["groupId"],
    },
  ],
  "Bundles & Packages": [
    {
      name: "Get Bundle Metrics",
      method: "GET",
      path: "/users/api/v1/bundle/metrics",
      fnName: "getBundleMetrics",
      params: ["ownerId"],
    },
    {
      name: "Get All Bundles",
      method: "GET",
      path: "/users/api/v1/bundle/all",
      fnName: "getAllBundles",
      params: [],
    },
    {
      name: "Create Bundle Purchase Order",
      method: "POST",
      path: "/users/api/v1/bundle/purchase/order/summary",
      fnName: "createBundlePurchaseOrder",
      params: ["bundleRequest"],
    },
    {
      name: "Assign Bundle",
      method: "POST",
      path: "/users/api/v1/bundle/package/assign/or/remove",
      fnName: "assignBundle",
      params: ["payload"],
    },
  ],
  Other: [
    {
      name: "Submit Enquiry",
      method: "POST",
      path: "/platform/company/api/v1/enquiry",
      fnName: "submitEnquiry",
      params: ["enquiry"],
    },
    {
      name: "Report Issue",
      method: "POST",
      path: "/platform/company/api/v1/issue/report",
      fnName: "reportIssue",
      params: ["issueDetails"],
    },
    {
      name: "Subscribe To Newsletter",
      method: "POST",
      path: "/platform/company/api/v1/newsletter/subscribe",
      fnName: "subscribeToNewsletter",
      params: ["email"],
    },
  ],
};
